

const validate = (values) => {

  const  errors = {};
   if (!values.code) {
    errors.code={
      ar: "يجب ادخال الرمز التاكيدي",
      en: "Required"
    }
   } 
   if (values.code&&values.code.length>5) {
    errors.code={
      ar: "يجب ادخال الرمز التاكيدي بعدد حروف او ارقام لا يزيد عن 5",
      en: "Confirmation Code length must be 5 characters"
    }
   } 
 
  return errors
 
}


export default validate;


